<template>
  <div>
    <!-- where are you -->
    <OpaSlideModal 
      title="Onde você está?" 
      direction="down" 
      v-model="whereAreYouModal"
      @slideModalClose="() => whereAreYouModal = false"
      >
        <b-row @click="showCompleteAddress = true" style="border-top:1px solid #DADADA;border-bottom:1px solid #DADADA;">
          <b-col cols="2" md="1" class="text-center align-self-center">
            <font-awesome-icon style="font-size:20px;" :style="{color:getCssColor('primary_bt')}"  :icon="['fal', 'search']"/>
          </b-col>
          <b-col style="color:#525962;font-size:20px;line-height:22px;padding-top:16px;padding-bottom:16px;">
            Buscar Endereço
          </b-col>
        </b-row>

        <!--b-row @click="getLocation()" style="border-bottom:1px solid #DADADA;">
          <b-col cols="2" md="1" class="text-center align-self-center">
            <font-awesome-icon style="font-size:20px;" :style="{color:getCssColor('primary_bt')}"  :icon="['fal', 'location']"/>
          </b-col>
          <b-col style="color:#525962;font-size:20px;line-height:22px;padding-top:16px;padding-bottom:16px;">
            Usar localização
          </b-col>
        </b-row-->

        <b-row @click="cepModal=true" style="border-bottom:1px solid #DADADA;">
          <b-col cols="2" md="1" class="text-center align-self-center">
            <font-awesome-icon style="font-size:20px;" :style="{color:getCssColor('primary_bt')}"  :icon="['fal', 'map-marker-alt']"/>
          </b-col>
          <b-col style="color:#525962;font-size:20px;line-height:22px;padding-top:16px;padding-bottom:16px;">
            Buscar por CEP
          </b-col>
        </b-row>
    </OpaSlideModal>


    <!-- address -->
    <OpaSlideModal 
      title="Buscar Endereço" 
      direction="down" 
      v-model="showCompleteAddress"
      @slideModalClose="() => showCompleteAddress = false"
      >
      <div style="overflow-y:auto;overflow-x:hidden;height:calc(100vh - 56px)">
        <b-row style="margin-top:20px;">
          <b-col>
            <OpaInputText type="text" v-model="city" placeholder="Cidade" :required="true"/>
          </b-col>
          <b-col>
            <OpaInputText type="text" v-model="state" placeholder="Estado" :required="true"/>
          </b-col>
        </b-row>
        <b-row style="margin-top:8px;">
          <b-col>
            <OpaInputText type="text" v-model="street" placeholder="Rua" :required="true"/>
          </b-col>
        </b-row>
        <b-row style="margin-top:8px;">
          <b-col>
            <OpaInputText type="text" name="street_number" v-model="street_number" autocomplete="off" spellcheck="false" autocorrect="off" placeholder="Número" :required="true"  :maxLength="10"/>
          </b-col>
        </b-row>
        <b-row style="margin-top:8px;">
          <b-col>
            <OpaInputText type="text" v-model="$store.state.tempAddress.cep" placeholder="CEP" :required="true"/>
          </b-col>
        </b-row>
        <b-row style="margin-top:8px;padding-bottom:16px;">
          <b-col>
            <OpaInputText type="text" v-model="more" placeholder="Complemento" :required="false"/>
          </b-col>
        </b-row>
        <b-row style="margin-top:20px;margin-bottom:20px;">
          <b-col style="text-align:center;">
            <button @click="getAdressByGoogle()" class="whereareu_button_solid" :style="{backgroundColor: getCssColor('primary_bt')}">CONTINUAR</button>
          </b-col>
        </b-row>
      </div>
    </OpaSlideModal>


    <!-- cep -->
    <OpaSlideModal 
      title="Buscar CEP" 
      direction="down" 
      v-model="cepModal"
      @slideModalClose="() => cepModal = false"
      >
      <div style="overflow-y:auto;overflow-x:hidden;height:calc(100vh - 56px)">
        <b-row style="margin-top:20px;">
          <b-col>
            <OpaInputText @inputEnter="() => {searchCep()}" type="text" v-model="$store.state.tempAddress.cep" placeholder="CEP" :required="true"/>
          </b-col>
        </b-row>
        <b-row style="margin-top:20px;margin-bottom:20px;">
          <b-col style="text-align:center;">
            <button @click="searchCep()" class="whereareu_button_solid" autocomplete="off" spellcheck="false" autocorrect="off" :style="{backgroundColor: getCssColor('primary_bt')}">BUSCAR</button>
          </b-col>
        </b-row>
      </div>
    </OpaSlideModal>

  </div>
</template>

<script>

import colors from '@/mixins/colors'
import OpaInputText from '@/components/OpaInputText'
import OpaSlideModal from '@/components/OpaSlideModal'
import LocationConn from '@/connection/location'
import { EventBus } from '@/behaviours/event-bus'
import UserConn from '@/connection/user'

export default {

  props: ['value'],
  
  data () {
    return {
      whereAreYouModal: false,
      showCompleteAddress: false,
      cepModal: false,

      city: null,
      state: null,
      street: null,
      street_number: null,
      more: null,

      cep: null
    }
  },

  mixins: [colors],

  components: {OpaInputText, OpaSlideModal},

  watch: {
    value (val) {
      this.whereAreYouModal = val
    },

    whereAreYouModal(val) {
      console.log('slide modal change')
      this.$emit('slideModalChange', val)
    }
  },

  methods: {
    getLocation () {
      if (navigator.geolocation) {
        this.$store.state.showLoading = true
        navigator.geolocation.getCurrentPosition(this.showPosition, (e) => {
          console.log(e)
          this.$store.state.showLoading = false
          EventBus.$emit('showAlert', 'error', 'Geolocalização não suportada')
        })
      } else {
        EventBus.$emit('showAlert', 'error', 'Geolocalização não suportada')
      }
    },

    async showPosition (position) {
      if (position.coords && position.coords.latitude && position.coords.longitude) {
        console.log(position)
        await this.getAddressByLocation (position.coords.latitude, position.coords.longitude)
      } else {
        this.$store.state.showLoading = false
        EventBus.$emit('showAlert', 'error', 'Não conseguimos encontrar sua geolocalização')
      }
    },

    async getAddressByLocation (lat, lng) {
      this.$store.state.showLoading = true
      let result = await LocationConn.getAddressByLocation(lat + ',' + lng)
      this.$store.state.showLoading = false
      
      console.log(result)
      if (result && result.results && result.results.length) {
        result.results[0].address_components.forEach((addr) => {
          console.log(addr.short_name)
          if (addr.types.indexOf('street_number') > -1){
            this.street_number = addr.short_name
          } else if (addr.types.indexOf('route') > -1){
            this.street = addr.short_name
          } else if (addr.types.indexOf('administrative_area_level_2') > -1){
            this.city = addr.short_name
          } else if (addr.types.indexOf('administrative_area_level_1') > -1){
            this.state = addr.short_name
          } else if (addr.types.indexOf('postal_code') > -1){
            this.cep = addr.short_name
            this.$store.state.tempAddress.cep = this.cep.toString()
          }
        })
      }

      this.whereAreYouModal = false
      this.showCompleteAddress = true
      
    },

    async searchCep () {
      if (this.validateCep()) {
        this.$store.state.showLoading = true
        this.cep = this.$store.state.tempAddress.cep.replace(/[^0-9]+/g, '').toString()
        let result = await LocationConn.getAdressByZipCode(this.$store.state.tempAddress.cep.replace(/[^0-9]+/g, '').toString())
        if (!result.error) {
          console.log(result)
          if (result.localidade) {
            let cepAddress = result
            this.street = cepAddress.logradouro
            this.city = cepAddress.localidade
            this.state = cepAddress.uf
            this.vicinity = (cepAddress.bairro && cepAddress.bairro.length ? cepAddress.bairro : null)
            this.$store.state.showLoading = false
            this.$forceUpdate()
            this.cepModal = false
            this.showCompleteAddress = true
          } else {
            this.$store.state.showLoading = false
            EventBus.$emit('showAlert', 'error', 'CEP não encontrado.')
          }
        } else {
          this.$store.state.showLoading = false
          EventBus.$emit('showAlert', 'error', result.msg)
        }
      } else {
        EventBus.$emit('showAlert', 'error', 'Preencha corretamente o cep para pesquisar.')
      }
    },

    async getAdressByGoogle () {


      console.log(this.street, this.street_number)

      if (this.validateForm()) {
        this.$store.state.showLoading = true
        let address = this.street + ',' + this.street_number + ' ' + this.city + ' ' + this.cep
        let result = await LocationConn.getAdressByGoogle(address)
        if (result) {
          console.log(result)
          this.latLong = result
          this.$store.state.lastLatLongUri = this.latLong.lat + '/' + this.latLong.lng
          this.continueWithAddress()
        } else {
          this.$store.state.showLoading = false
          EventBus.$emit('showAlert', 'error', 'Não foi possível verificar o endereço, verifique as informações.')
        }
      } else {
        EventBus.$emit('showAlert', 'warning', 'Os campos Rua, Número e CEP são obrigatórios.')
      }
      
    },

    validateForm () {
      if (this.validateCep () &&
          this.validateStreet() &&
          this.validateNumber()
      ) {
        return true
      } else {
        return false
      }
    },

    validateCep () {
      this.$forceUpdate()
      return this.$store.state.tempAddress.cep && this.$store.state.tempAddress.cep.length.toString() > 7
    },

    validateStreet () {
      return this.street && this.street.length > 2
    },

    validateNumber () {
      return this.street_number && this.street_number.length > 0
    },

    async continueWithAddress () {
      this.$store.state.selectedAddressShort = this.street + ',' + this.street_number
      this.$store.state.tempAddress = {
        city: this.city,
        state: this.state,
        number: this.street_number,
        street: this.street,
        more: this.more,
        cep: this.cep,
        vicinity: this.vicinity,
        country: 'Brasil', // TODO fix by now always BR
        latLong: this.latLong
      }

      if (this.$store.state.user) {
        await UserConn.saveAddress(this.$store.state.user.id,
          this.$store.state.tempAddress.street,
          this.$store.state.tempAddress.number,
          this.$store.state.tempAddress.more,
          this.$store.state.tempAddress.vicinity,
          this.$store.state.tempAddress.city,
          this.$store.state.tempAddress.state,
          this.$store.state.tempAddress.country,
          this.$store.state.tempAddress.cep,
          this.$store.state.tempAddress.latLong)
      }

      this.$emit('continueWithAddress', this.latLong)

      this.whereAreYouModal = false
      this.showCompleteAddress = false
      this.cepModal = false
    },

  }
}
</script>

<style lang="scss">

.whereareu_button_solid {
  width: 100%;
  max-width: 311px;
  height: 44px;
  color: #ffffff;
  font-weight: 500;
  border-radius: 8px;
}

</style>
